// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"61e9c327","453":"3b9b5096","956":"8ef05137"}[chunkId] + ".chunk.js";
};